import { Link } from 'react-router';
import type { TileSize } from '../../../tiles/registry';
import { Money, Num } from '../../../ui';
import { PlusOneButton } from '../components/PlusOneButton';
import { copy } from '../copy';
import { QUIT_BASE } from '../dashboardDefaults';
import { durationText, spokenCount, statusLine } from '../format';
import { useLogCigarette, useQuitOverview } from '../hooks';
import { FOCUS } from '../styles';

/** "Cigarettes today" with its own 44px +1 (design.md: tile actions are their own buttons). */
export function QuitTodayTile({ size }: { size: TileSize; config: unknown }) {
  const q = useQuitOverview();
  const log = useLogCigarette();
  if (!q) return <p className="text-sm text-muted">{copy.loading}</p>;
  const o = q.overview;
  if (!o) {
    return (
      <div role="group" aria-label={`${copy.cigarettesToday}, ${copy.setUpPlan}`}>
        <Link
          to={`${QUIT_BASE}/plan`}
          className={`inline-flex min-h-11 items-center text-primary ${FOCUS}`}
        >
          {copy.setUpPlan}
        </Link>
      </div>
    );
  }
  const status = statusLine(o);
  return (
    <div role="group" aria-label={spokenCount(o.count, o.limit)} className="flex flex-col gap-1">
      <div className="flex items-center justify-between gap-2">
        <Link
          to={QUIT_BASE}
          className={`min-w-0 font-mono text-[36px] leading-tight tabular-nums text-fg ${FOCUS}`}
        >
          <Num value={o.count} />
          {o.limit !== null ? <span className="ml-1 text-xl text-muted">/ {o.limit}</span> : null}
        </Link>
        <PlusOneButton size="sm" onPress={() => void log()} />
      </div>
      {status ? <p className="text-sm text-muted">{status}</p> : null}
      {size === 'wide' ? (
        <p className="text-sm text-muted">
          {o.lastSmokeAt && o.minutesSince !== null
            ? copy.lastOne(durationText(o.minutesSince))
            : copy.noneYet}
          {o.hasPrice ? (
            <>
              {' · '}
              <Money minor={o.spentToday} animate={false} />
            </>
          ) : null}
        </p>
      ) : null}
    </div>
  );
}
